import { render, staticRenderFns } from "./MiniProgramModal.vue?vue&type=template&id=7b4cc83d&scoped=true"
import script from "./MiniProgramModal.vue?vue&type=script&lang=js"
export * from "./MiniProgramModal.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramModal.vue?vue&type=style&index=0&id=7b4cc83d&prod&scoped=true&lang=css"
import style1 from "./MiniProgramModal.vue?vue&type=style&index=1&id=7b4cc83d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4cc83d",
  null
  
)

export default component.exports